import Slider from './Slider.js';
import Dot from './Dot.js';
import DotTemplate from './DotTemplate.js';
import Fill from './Fill.js';
import FillTemplate from './FillTemplate.js';
export { useSliderConfig, useSliderValue } from './SliderContext.js';
import 'react';
import '@dtvgo/utils';
import './utils.js';
import '@dtvgo/classnames';
import './Slider.scss';
import 'react/jsx-runtime';
import '@babel/runtime/helpers/esm/defineProperty';
import '@babel/runtime/helpers/esm/objectSpread2';
import '@dtvgo/slider-dot';

Slider.Dot = Dot;
Slider.DotTemplate = DotTemplate;
Slider.Fill = Fill;
Slider.FillTemplate = FillTemplate;

export { Slider as default };
//# sourceMappingURL=index.js.map
